module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAHCAYAAADebrddAAAA5UlEQVQoU2MMD4m88f//3/xVa1ftZMABIkIinP8zME5lDAuOSGVkZOz9x/jHcfXq1WfR1QcHRxiyMjHu////Xy0jSDI0NDyN6T9Tz+9/P3XXrVv3EKYhKChInpWZ7SIDw//6latXTgQrBoGwoMhiJmaG5o/nPwhuv7P9p6enJzsfN/8bRgaG9hVrVrSB1MAVh4aGMjP+ZW5iZGZI/cfwV5WZgeXafwaGpS9fP686cODAHxTFEOeEMjP9Z5rByMgUw/Dv/4rbD26nnT179jfMdrjJMIEGhgam60HXU+48vDMfWSFIHgDl6ldTVOdg1wAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/arrow-down.png
// module id = 175
// module chunks = 0